import { render, staticRenderFns } from "./VeJwJingsaiScoreList.vue?vue&type=template&id=6400381d&scoped=true"
import script from "./VeJwJingsaiScoreList.vue?vue&type=script&lang=js"
export * from "./VeJwJingsaiScoreList.vue?vue&type=script&lang=js"
import style0 from "./VeJwJingsaiScoreList.vue?vue&type=style&index=0&id=6400381d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6400381d",
  null
  
)

export default component.exports